import "../../../V2SideDrawer.css";
import { DRAWER_TAB_ICONS } from "./drawerTabIcons";

// Icon-only drawer tab bar shared by every side drawer. Each tab:
//   { key, label, icon, badge?, badgeTone?, showZero? }
// `icon` is a DRAWER_TAB_ICONS key (or a React node); `label` is shown as the
// hover/focus tooltip and used as the accessible name. `badge` (a count) sits
// on the icon's corner (a 0 count is hidden unless `showZero`); `badgeTone` is
// "warn" | "danger" for colored badges.
// A tab without an icon falls back to rendering its text label.
export default function DrawerTabs({ tabs = [], activeTab, onChange }) {
  return (
    <div className="v2drw-tabs v2drw-tabs--icons" role="tablist">
      {tabs.map((t) => {
        const icon = typeof t.icon === "string" ? DRAWER_TAB_ICONS[t.icon] : t.icon;
        const active = activeTab === t.key;
        const hasBadge = t.badge !== undefined && t.badge !== null && t.badge !== false
          && (t.badge !== 0 || t.showZero);
        const tip = hasBadge ? `${t.label} (${t.badge})` : t.label;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            aria-label={icon ? tip : undefined}
            data-tip={icon ? tip : undefined}
            className={`v2drw-tab${icon ? " v2drw-tab--icon" : ""}${active ? " v2drw-tab--active" : ""}`}
            onClick={() => onChange?.(t.key)}
          >
            {icon || t.label}
            {hasBadge && (
              <span className={`v2drw-tab-badge${t.badgeTone ? ` v2drw-tab-badge--${t.badgeTone}` : ""}`}>
                {t.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
